mainApp.directive('sidePanelField', function() {
    return {
        templateUrl: '/public/components/discovery/side-panel-field.directive.html',
        restrict: 'A',
        link: function(ctrl, el, attrs) {
            ctrl.name = ctrl.$eval(attrs.name);

            ctrl.hasNA = false;

            ctrl.getUsagesArray = function(obj) {
                const result = [];
                _.forOwn(obj, function(value, key) {
                    if (value === 0)
                        return;

                    if (key === 'N/A')
                        ctrl.hasNA = true;

                    result.push({
                        value: key,
                        amount: value,
                        order: key === 'N/A' ? -1 : value
                    });
                });
                return result;
            };

            ctrl.$watch(attrs.totalCount, function(val) {
                ctrl.totalCount = val;
            });

            ctrl.$watch(attrs.fieldsSpec, function(val) {
                ctrl.fieldsSpec = val;
                ctrl.isCardinalityRelevant = ctrl.name !== 'event_data' && ctrl.fieldsSpec[ctrl.name].type !== 'text';
            });

            ctrl.$watch(attrs.cardinality, function(val) {
                ctrl.cardinality = val;
                ctrl.isCardinalityExists = typeof val !== 'undefined';
            });

            ctrl.$watch(attrs.usages, function(val) {
                ctrl.usages = ctrl.getUsagesArray(val);

                if (!val && ctrl.expanded) {
                    ctrl.$eval(attrs.onFetchUsages, {field: ctrl.name, amount: 5});
                }
            });

            ctrl.hasAdd = attrs.onColumnAdd ? true : false;
            ctrl.hasRemove = attrs.onColumnRemove ? true : false;

            ctrl.expanded = false;

            ctrl.toggleUsages = function() {
                ctrl.expanded = !ctrl.expanded && ctrl.isCardinalityRelevant;
                if (ctrl.expanded)
                    ctrl.$eval(attrs.onFetchUsages, {field: ctrl.name, amount: 5});
            };

            ctrl.addFilter = function(value, operator) {
                ctrl.$eval(attrs.onAddFilter, {field: ctrl.name, operator: operator, value: value});
            };

            ctrl.addColumn = function() {
                ctrl.$eval(attrs.onColumnAdd, {field: ctrl.name});
            };

            ctrl.removeColumn = function() {
                ctrl.$eval(attrs.onColumnRemove, {field: ctrl.name});
            };

            ctrl.formatValue = function(value) {
                return ctrl.$eval(attrs.valueFormatter, {field: ctrl.name, value: value});
            };

            ctrl.loadMoreUsages = function() {
                ctrl.$eval(attrs.onFetchUsages, {field: ctrl.name, amount: ctrl.usages.length + 5});
            };
        }
    }
});